import { isNullish } from 'common/utils/utils';
import { RootState } from 'store';

export const getMagicMovieUserName = (state: RootState) => {
  return isNullish(state?.magicMovie?.userName) ? 'SuperMovieFan' : state?.magicMovie?.userName;
};

export const getActualUserName = (state: RootState) => {
  return isNullish(state?.magicMovie?.userName) ? '' : state?.magicMovie?.userName;
};

export const getMagicMovieUserId = (state: RootState) => state?.magicMovie?.userId;
export const getMagicMovieAvatar = (state: RootState) => state?.magicMovie?.avatar;
export const getPopularMovies = (state: RootState) => state?.magicMovie?.popularMovies;
export const getRecommendedMovies = (state: RootState) => state?.magicMovie?.recommendedMovies;
export const getSelectedMovies = (state: RootState) => state?.magicMovie?.selectedMovies;
export const getSelectedMoviesForTab = (state: RootState) => state?.magicMovie?.selectedMoviesForTab;
